export default __webpack_public_path__ + "fonts/Overpass-ExtraBold.ttf";